module.exports = "module.exports = __webpack_public_path__ + &quot;search.svg?57f046941f7cc68cb6ba1a5fcc6a1934&quot;;"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./src/assets/icons/ui/search.svg
// module id = 83
// module chunks = 0